module.exports = __webpack_public_path__ + "static/media/back.799943f0.svg";